import type { FC } from 'react';
import { TooltipOnTruncated } from '@components/TooltipOnTruncated';
import { Spinner } from '@components/ui/spinner';
import clsx from 'clsx';

interface SavedViewRowProps {
  name: string;
  count?: number;
  loading?: boolean;
  active: boolean;
  onClick: () => void;
}

export const SavedViewRow: FC<SavedViewRowProps> = ({ name, count, loading, active, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    aria-current={active ? 'true' : undefined}
    className={clsx(
      'text-info-300 group flex w-full items-center gap-x-2 rounded-md px-2 py-1.5 text-sm',
      active ? 'bg-info-900' : 'hover:bg-info-700 hover:text-white',
    )}
  >
    {/* Tooltip only when the name is actually truncated, matching the listing table cells. */}
    <TooltipOnTruncated tooltipContent={name} className="grow cursor-pointer text-left">
      {name}
    </TooltipOnTruncated>
    {typeof count === 'number' && (
      <span className="bg-info-900 text-info-300 inline-flex h-5 min-w-8 items-center justify-center gap-x-1 rounded-full px-1 text-xs">
        {count}
        {loading && <Spinner className="size-3" />}
      </span>
    )}
  </button>
);
